import socket from "./socket";

export default (id, data) => {
  data.type = id;
  socket.send(JSON.stringify(data));
};
